package app.smartcoding.realrate.domain.model

import androidx.compose.runtime.Stable
import app.smartcoding.realrate.AD_MOB_APP_ID
import app.smartcoding.realrate.AD_MOB_UNIT_ID
import app.smartcoding.realrate.AD_SENSE_PUB_ID
import app.smartcoding.realrate.AD_SENSE_SLOT_ID

@ConsistentCopyVisibility
@Stable
data class AdBannerData internal constructor(
    val adMobAppId: String,
    val adMobUnitId: String,
    val adSensePublisherId: String,
    val adSenseSlotId: String,
)

val adBannerData by lazy {
    AdBannerData(
        adMobAppId = AD_MOB_APP_ID,
        adMobUnitId = AD_MOB_UNIT_ID,
//        adMobUnitId = AD_MOB_TEST_UNIT_ID,
        adSensePublisherId = AD_SENSE_PUB_ID,
        adSenseSlotId = AD_SENSE_SLOT_ID
    )
}


